import React, { useContext } from "react";
import {
  numricFieldArray,
  isNotRequiredFieldArray,
  areaCodesArray,
} from "../../Utilities/arrayUtil";
import appConst from "../../Utilities/appConst.json";
import { LanguageContext } from "../../context/language/LanguageContext";
import { getLanguageDirection } from "../../Utilities/languageDirection";
import { FloatingLabelInput } from "../ui/floating-label-input";
import { FloatingLabelSelect } from "../ui/floating-label-select";
import { FloatingLabelAutocomplete } from "../ui/floating-label-autocomplete";

const InputField = ({
  section,
  label,
  value,
  onChange,
  onSelect,
  error,
  helperText,
  options,
  disabled,
  maxLength,
}) => {
  const FIXED_OPTIONS_LENGTH = 500;
  const languageContext = useContext(LanguageContext);
  const fieldDirection = getLanguageDirection(languageContext.language?.id);

  const isNotRequired = (label) =>
    isNotRequiredFieldArray.find((field) => field === label);
  const isNumeric = (label) =>
    Boolean(numricFieldArray.find((field) => field === label));
  const testId = `${label}_${section}`;
  const translatedLabel = languageContext.getTranslation(label) || label;
  const isRequiredField = !isNotRequired(label);
  const inputTextAlign = fieldDirection === "rtl" ? "right" : "left";
  const noOptionsText = languageContext.getTranslation(
    appConst.VALIDATION_TEXT_NOT_ON_THE_LIST
  );

  return label === appConst.AREA_CODE ? (
    <FloatingLabelSelect
      id={testId}
      label={translatedLabel}
      required={isRequiredField}
      invalid={error}
      errorText={helperText ? `${helperText} ${translatedLabel}` : undefined}
      disabled={disabled}
      dir={fieldDirection}
      value={value || ""}
      onValueChange={(selectedValue) => onChange(selectedValue)}
      options={areaCodesArray.map((item) => ({
        value: String(item.value),
        label: item.label,
        disabled: item.disabled,
      }))}
      allowClear
      clearLabel={languageContext.getTranslation(appConst.CLEAR)}
      className="w-full"
      dataTestId={testId}
    />
  ) : label === appConst.CITY ||
    label === appConst.STREET ||
    label === appConst.COMPANY_CITY ||
    label === appConst.COMPANY_STREET ? (
    <FloatingLabelAutocomplete
      id={testId}
      label={translatedLabel}
      required={isRequiredField}
      invalid={error}
      errorText={helperText}
      disabled={disabled || !(options?.length)}
      dir={fieldDirection}
      value={value || ""}
      options={options || []}
      onValueChange={onChange}
      onSelect={onSelect}
      noOptionsText={noOptionsText}
      maxOptions={FIXED_OPTIONS_LENGTH}
      dataTestId={testId}
    />
  ) : (
    <div
      dir={fieldDirection}
      className="flex w-full flex-col"
    >
      <FloatingLabelInput
        id={testId}
        label={translatedLabel}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={isRequiredField}
        invalid={error}
        errorText={helperText}
        dir={fieldDirection}
        inputMode={isNumeric(label) ? appConst.TEL : ""}
        maxLength={maxLength}
        style={{ textAlign: inputTextAlign, direction: fieldDirection }}
        data-testid={testId}
      />
    </div>
  );
};

export default InputField;
